<template>
  <div v-if="story" v-loading="loading" class="update-story">
    <section class="header">
      <div class="col">
        <div class="mb-15 row">
          <div class="desc require">故事名称</div>
          <el-input v-model="story.name" placeholder="请输入故事名称" />
        </div>
        <div class="row mb-15">
          <div class="desc">故事分类</div>
          <el-select v-model="storyType.value" value-key="code" placeholder="请选择故事分类">
            <el-option v-for="(type,i) in typeList" :key="type.code" :label="type.value" :value="type"/>
          </el-select>
        </div>
        <div class="row">
          <div class="desc">场景</div>
          <el-select ref="sceneSelect" v-model="currentScene" value-key="scene" placeholder="请选择场景" @change="changeScene">
            <el-option v-for="(scene,i) in scenes" :key="scene.scene" :label="scene.scene" :value="scene">
              <span>{{ scene.scene }}</span>
              <i class="el-icon-remove-outline del-icon" @click.stop="delScene(i,scene)" />
            </el-option>
          </el-select>
          <i class="el-icon-circle-plus-outline add-icon" @click="addScene" />
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="desc">故事描述</div>
          <el-input v-model="story.description" rows="3" type="textarea" placeholder="请输入故事描述" />
        </div>
      </div>
      <div class="col">
        <el-button @click="saveData">保存</el-button>
      </div>
    </section>
    <section v-if="JSON.stringify(currentScene)!=='{}'&&!currentScene.del" class="content">
      <div class="scene">
        <div class="col">
          <div class="mb-15 row">
            <div class="desc require">场景名称</div>
            <el-input v-model="currentScene.scene" placeholder="请输入场景名称" />
          </div>
          <div class="row">
            <div class="desc">步骤</div>
            <el-select v-model="currentTask" value-key="task" placeholder="请选择步骤">
              <el-option v-for="(task,t_i) in currentScene.tasks" :key="task.task" :label="task.task" :value="task">
                <span>{{ task.task }}</span>
                <i class="el-icon-remove-outline del-icon" @click.stop="delTask(t_i,task)" />
              </el-option>
            </el-select>
            <i class="el-icon-circle-plus-outline add-icon" @click="addTask" />
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="desc">场景描述</div>
            <el-input v-model="currentScene.description" rows="3" type="textarea" placeholder="请输入场景描述" />
          </div>
        </div>
      </div>
    </section>
    <section v-if="JSON.stringify(currentTask)!=='{}'&&!currentTask.del" class="task">
      <div class="row">
        <el-col :span="12">
          <div class="desc require">步骤名称</div>
          <el-input v-model="currentTask.task" placeholder="请输入步骤名称" />
        </el-col>
        <el-col :span="12">
          <div class="desc">步骤描述</div>
          <el-input v-model="currentTask.description" rows="3" type="textarea" placeholder="请输入步骤描述" />
        </el-col>
      </div>
      <div class="row qas">
        <el-col :span="12">
          <div class="mb-15">问答合集</div>
          <div class="auto">
            <div v-for="(qas,index) in currentTask.qaPairs" :key="index">
              <div class="qa">
                <el-col class="require" :span="6">问题：</el-col>
                <el-col :span="18">
                  <div v-for="(qa,i) in qas.questions" :key="i">
                    <el-input v-model="qas.questions[i]" type="textarea" :rows="2" />
                  </div>
                </el-col>
              </div>
              <div class="qa">
                <el-col class="require" :span="6">答案：</el-col>
                <el-col :span="18"><el-input v-model="qas.answer" type="textarea" :rows="4" /></el-col>
              </div>
              <div class="qa">
                <el-col class="require" :span="6">问题意图：</el-col>
                <el-col :span="18"><el-input v-model="qas.questionIntent" type="textarea" :rows="2" /></el-col>
              </div>
              <div class="qa">
                <el-col class="require" :span="6">答案意图：</el-col>
                <el-col :span="18"><el-input v-model="qas.answerIntent" type="textarea" :rows="2" /></el-col>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" class="checkList">
          <div class="mb-15 require">
            检查点
            <i class="el-icon-circle-plus-outline" @click="addCheck" />
          </div>
          <div class="auto">
            <div v-for="(check,c_i) in currentTask.checkList" :key="c_i" class="check">
              <el-input v-model="currentTask.checkList[c_i]" type="textarea" :rows="2" />
              <i class="el-icon-remove-outline" @click="currentTask.checkList.splice(c_i,1)" />
            </div>
          </div>
        </el-col>
      </div>
    </section>
  </div>
</template>

<script>
import { storyDetail, updateStory, getStoryType } from '@/api/exercise'
export default {
  data() {
    return {
      currentScene: {},
      currentTask: {},
      story: null,
      loading: false,
      storyType: {},
      typeList:[],
      scenes: []
    }
  },
  created() {
    // if (this.$route.params.story) {
    //   localStorage.setItem('currentStory', JSON.stringify(this.$route.params.story))
    // }
    // this.story = JSON.parse(localStorage.getItem('currentStory'))
    // this.scenes = this.story.scenes
    // console.log('story', this.story)
    this.queryStory()
    this.getType()
  },
  methods: {
    getType() {
      getStoryType().then(res=> {
        console.log('getStoryType', res);
        this.typeList = res.data;
      })
    },
    // 验证task数据完整
    validateTask(val, scene) {
      const qaPairs = val.qaPairs[0]
      if (!val.task) {
        this.$message({
          message: `请先填写完整"${scene}"场景下的无名称的步骤`,
          type: 'error',
          duration: 5 * 1000
        })
        return false
      } else if (!val.checkList.length || (val.checkList.length === 1 && !val.checkList[0])) {
        this.$message({
          message: `请填写"${scene}"场景下的“${val.task}”步骤下的检查点，至少为一条`,
          type: 'error',
          duration: 5 * 1000
        })
        return false
      } else if (!qaPairs.answer || !qaPairs.answerIntent || !qaPairs.questionIntent || !qaPairs.questions[0]) {
        this.$message({
          message: `请完善"${scene}"场景下的“${val.task}”步骤下的问答合集`,
          type: 'error',
          duration: 5 * 1000
        })
        return false
      } else {
        return true
      }
    },
    changeScene() {
      this.currentTask = {}
    },
    addScene() {
      if (!this.scenes.length) {
        this.currentTask = {}
        this.currentScene = {
          scene: '',
          description: '',
          tasks: []
        }
        this.scenes.push(this.currentScene)
      } else {
        let b = false
        for (let i = 0; i < this.scenes.length; i++) {
          const scene = this.scenes[i]
          if (b) {
            break
          }
          if (!scene.scene) {
            this.$message({
              message: `请先完善没有名称的场景`,
              type: 'error',
              duration: 5 * 1000
            })
            break
          } else if (!scene.tasks.length) {
            this.$message({
              message: `请先添加"${scene.scene}"场景下的步骤，至少为一个`,
              type: 'error',
              duration: 5 * 1000
            })
            break
          } else {
            for (let s_i = 0; s_i < scene.tasks.length; s_i++) {
              const task = scene.tasks[s_i]
              const isNext = this.validateTask(task, scene.scene)
              if (isNext && i === this.scenes.length - 1 && s_i === scene.tasks.length - 1) {
                this.currentTask = {}
                this.currentScene = {
                  scene: '',
                  description: '',
                  tasks: []
                }
                this.scenes.push(this.currentScene)
                b = true
                break
              } else if (!isNext) {
                break
              }
            }
          }
        }
      }
    },
    delScene(index, scene) {
      this.$confirm('此操作将删除该场景及其所有的步骤和相关的问答合集和检查点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (scene.scene === this.currentScene.scene) {
          this.currentScene = {
            scene: '',
            del: true
          }
          this.currentTask = {}
        }
        this.scenes.splice(index, 1)
      })
    },
    addTask() {
      if (!this.currentScene.scene) {
        this.$message({
          message: `请先完善场景名称`,
          type: 'error',
          duration: 5 * 1000
        })
        return false
      }
      if (!this.currentScene.tasks.length) {
        this.currentTask = {
          task: '',
          description: '',
          checkList: [],
          qaPairs: [
            {
              answer: '',
              answerIntent: '',
              questionIntent: '',
              questions: ['']
            }
          ]
        }
        this.currentScene.tasks.push(this.currentTask)
      } else {
        for (let i = 0; i < this.currentScene.tasks.length; i++) {
          const task = this.currentScene.tasks[i]
          const isNext = this.validateTask(task, this.currentScene.scene)
          if (isNext && i === this.currentScene.tasks.length - 1) {
            this.currentTask = {
              task: '',
              description: '',
              checkList: [],
              qaPairs: [
                {
                  answer: '',
                  answerIntent: '',
                  questionIntent: '',
                  questions: ['']
                }
              ]
            }
            this.currentScene.tasks.push(this.currentTask)
            break
          } else if (!isNext) {
            break
          }
        }
      }
    },
    delTask(index, task) {
      this.$confirm('此操作将删除该任务及其问答合集和检查点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        task.task === this.currentTask.task && (this.currentTask = {
          task: '',
          del: true
        })
        this.currentScene.tasks.splice(index, 1)
      })
    },
    queryStory() {
      storyDetail({ id: this.$route.params.story._id }).then(res => {
        console.log('res', res)
        this.story = res.data
        this.scenes = this.story.scenes
        this.typeList.forEach(el => {
        if(el.code === res.data.storyType) {
          this.storyType = el;
        }
        })
      })
    },
    
    addCheck() {
      const cl = this.currentTask.checkList.filter(item => !item)
      if (cl && cl.length) {
        this.$message({
          message: `请先完善检查点`,
          type: 'error',
          duration: 5 * 1000
        })
      } else {
        this.currentTask.checkList.push('')
      }
    },
    saveData() {
      let b = false
      for (let i = 0; i < this.scenes.length; i++) {
        const scene = this.scenes[i]
        if (b) {
          break
        }
        if (!scene.scene) {
          this.$message({
            message: `请先完善没有名称的场景`,
            type: 'error',
            duration: 5 * 1000
          })
          break
        } else if (!scene.tasks.length) {
          this.$message({
            message: `请先添加"${scene.scene}"场景下的步骤，至少为一个`,
            type: 'error',
            duration: 5 * 1000
          })
          break
        } else {
          for (let s_i = 0; s_i < scene.tasks.length; s_i++) {
            const task = scene.tasks[s_i]
            const isNext = this.validateTask(task, scene.scene)
            if (isNext && i === this.scenes.length - 1 && s_i === scene.tasks.length - 1) {
              this.loading = true
              console.log('this.story', this.story)
              updateStory(this.story).then(() => {
                this.$message({
                  message: `保存成功`,
                  type: 'success',
                  duration: 5 * 1000
                })
                this.$router.push({ name: 'storyList' })
              }).finally(() => {
                this.loading = false
              })
            } else if (!isNext) {
              b = true
              break
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mb-15{
  margin-bottom: 15px;
}
.require{
  position: relative;
  padding-left: 10px;
  &::before{
    position: absolute;
    left: 0;
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
}
.add-icon{
  display: flex;
  align-items: center;
  margin-left: 5px;
  font-size: 20px !important;
}
.el-select-dropdown__item{
  display: flex;
  justify-content: space-between;
}
.del-icon{
  display: flex;
  align-items: center;
  margin-left: 5px;
  font-size: 20px !important;
  color: red;
}
.desc{
  width: 100px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.update-story{
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  ::v-deep{
    .el-select{
      flex: 1;
    }
    .el-input__inner{
      font-size: 14px;
    }
    .el-textarea__inner{
      resize: none;
      font-size: 14px;
    }
    .el-col-12{
      display: flex;
    }
    .el-col-12:last-child{
      margin-left: 50px;
    }
    .el-icon-circle-plus-outline{
      font-size: 15px;
      color: green;
    }
  }
  .header{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid #EBEEF5;
    padding: 15px 20px;
    padding-bottom: 20px;
    font-size: 14px;
    .col{
      width: 38%;
    }
    .col:nth-child(2){
      width: 45%;
    }
    .col:last-child{
      width: auto;
      text-align: right;
      ::v-deep{
        .el-button{
          color: #fff;
          background: #419eee;
        }
      }
    }
    .row{
      display: flex;
    }
  }
  .content{
    .scene{
      display: flex;
      padding: 15px 20px;
      border-bottom: 1px solid #EBEEF5;
      align-items: center;
      .col{
        width: 50%;
      }
      .col:last-child{
        margin-left: 50px;
      }
      .row{
        display: flex;
      }
    }
  }
  .task{
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    overflow: hidden;
    .qas{
      flex:1;
      overflow: hidden;
      ::v-deep{
        .el-col-12{
          flex-direction: column;
          padding: 10px 0;
          font-size: 14px;
        }
        .el-col-12:last-child{
          padding: 10px 0 10px 30px;
          border-left: 1px solid #EBEEF5;
          margin-left: 30px;
        }
        .el-col-6,.el-col-18{
          line-height: 25px;
        }
        .el-col-6 {
          color: #6c6c6c;
          width: 100px;
        }
        .el-col-18{
          flex: 1;
        }
        .el-col-18:first-child{
          margin-top: 5px;
        }
        .qa{
          display: flex;
          margin-bottom: 20px;
        }
      }
    }
    .check{
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      border: 1px solid #DCDFE6;
      padding-right: 10px;
      border-radius: 4px;
    }
    .checkList{
      ::v-deep{
        .el-textarea__inner{
          border: 0;
          border-radius: 0;
          border-right: 1px solid #DCDFE6;
          padding: 5px 10px 5px 15px;
        }
        .el-icon-remove-outline{
          font-size: 20px;
          margin-left: 10px;
          color: red;
        }
      }
    }
    .row{
      display: flex;
      padding: 15px 20px;
      border-bottom: 1px solid #EBEEF5;
    }
    .row:first-child{
      padding-bottom: 15px;
      align-items: center;
    }
    .col{
      width: 50%;
    }
    .col:first-child{
      border-right: 1px solid #EBEEF5;
    }
    .auto{
      overflow: auto;
    }
  }
}
</style>
